import { Directive, HostBinding, HostListener } from '@angular/core';
import { TCCPCommonService } from '../services/tccp-common.service';

@Directive({
  selector: '[orientation]'
})
export class OrientationDirective {

  constructor(private commonService: TCCPCommonService) { }
  @HostBinding('class') state;

  ngOnInit() {
    this.updateOrientatioState();
  }

  @HostListener('window:resize') updateOrientatioState() {
    if (window.innerHeight > window.innerWidth) {
      this.state = 'portrait';
    } else {
      this.state = 'landscape';
    }
    this.commonService.removeZoom.emit(this.state);
  }
}
